import { FC, useMemo } from "react";
import { StyledAvatar } from "styles/components/avatar";

interface AvatarProps {
  name?: string;
  size?: "sm" | "md" | "lg";
  variant?: "circular" | "rounded" | "square";
  alt?: string;
  src?: string;
  srcSet?: string;
  bgColor?: string;
  withBlur?: boolean;
  className?: string;
  dataTestId?: string;
}

const Avatar: FC<AvatarProps> = ({
  name,
  size,
  variant,
  alt,
  src,
  srcSet,
  bgColor,
  withBlur,
  className,
  dataTestId,
}) => {
  const renderedInitials = useMemo(() => {
    let initials;

    if (name?.indexOf(" ") !== -1) {
      initials = `${name?.split(" ")[0][0]}${name?.split(" ")[1][0]}`;
    } else {
      initials = `${name[0]}`;
    }

    return name ? initials.toLocaleUpperCase() : null;
  }, [name]);

  return (
    <StyledAvatar
      src={src}
      size={size}
      variant={variant}
      alt={alt}
      srcSet={srcSet}
      bgColor={bgColor}
      withBlur={withBlur}
      className={className}
      data-testid={dataTestId}
    >
      {renderedInitials}
    </StyledAvatar>
  );
};

export default Avatar;
